import React, { useRef, useEffect, useState } from 'react';
import './VideoShowcase.css';

export default function VideoShowcase({ 
  src = "https://cdn.shopify.com/videos/c/o/v/0d8845e6bf9c4be8af8162d1263b7a8e.mp4",
  showText = true 
}) {
  const videoRef = useRef(null);
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    const el = videoRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setShouldLoad(true);
          observer.disconnect();
        }
      },
      { rootMargin: '200px' }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (shouldLoad && videoRef.current) {
      videoRef.current.play().catch(() => {});
    }
  }, [shouldLoad, src]);

  return (
    <section className={`video-showcase${!showText ? ' video-showcase--inline' : ''}`} id={showText ? "video-showcase-top" : "video-showcase-bottom"}>
      <video
        ref={videoRef}
        className="video-showcase__bg"
        src={shouldLoad ? src : undefined}
        autoPlay={shouldLoad}
        muted
        loop
        playsInline
        preload="none"
        poster="/playermaker_box_transparent.webp"
      />
      {showText && <div className="video-showcase__overlay" />}
      {showText && (
        <div className="video-showcase__content container">
          <h2 className="video-showcase__title">
            TRAIN SMARTER. PLAY HARDER.
          </h2>
          <p className="video-showcase__subtitle">
            IMPROVE INSTANTLY WITH THE ONLY FIFA APPROVED, WEARABLE, SMART SOCCER TRACKER THAT STRAPS AROUND YOUR BOOT.
          </p>
        </div>
      )}
    </section>
  );
}
